import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leagues: [],
  isLeaguesLoading: false,
  selectedLeague: null, // 'connected', 'connecting', 'error', 'disconnected'
};

const leagueSlice = createSlice({
  name: "league",
  initialState,
  reducers: {
    setSelectedLeague: (state, action) => {
      state.selectedLeague = action.payload;
    },
    setLeagues: (state, action) => {
      state.leagues = action.payload;
    },
    // Loading state
    setLeaguesLoading: (state, action) => {
      state.isLeaguesLoading = action.payload;
    },
  },
});

// Actions
export const { setSelectedLeague, setLeagues, setLeaguesLoading } =
  leagueSlice.actions;

export const selectSelectedLeague = (state) => state.league.selectedLeague;
export const selectLeagues = (state) => state.league.leagues;
export const selectLeaguesIsLoading = (state) => state.league.isLeaguesLoading;

export const leagueReducer = leagueSlice.reducer;
